/* eslint-disable no-unused-expressions */
/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/label-has-associated-control */
import moment from "moment-business-days";
import React, { useEffect, useMemo, useState } from "react";
import { Switch, FormControlLabel } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import DataTable from "react-data-table-component";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import { UncontrolledTooltip } from "reactstrap";
import DatePicker from "react-datepicker";
import Dropdown from "react-bootstrap/Dropdown";
import { Bell, BellOff, CircleCheck, CirclePercent, Clock9, Focus, Plus, Share2, SlidersHorizontal, SquarePercent } from "lucide-react";
import { humanDateFormat, NotasDePedidoKpiIcons } from "../../../config/constants";
import { BlurSpinner } from "../../components/BlurSpinner";
import Breadcrumb from "../../components/common/breadcrumb";
import { ShowSearchBar } from "../../components/SearchBar";
import { useSearchBar } from "../../components/SearchBar/context/SearchBarContext";
import { StylesDatePicker } from "../../ui/stylesDatePicker";
import { configDatePickerLenguage } from "../../components/RelevosInfoGeneral/utils";
import { useAuth } from "../../context/AuthContext";
import useFetcher from "../../hooks/useFetcher";
import usePaging from "../../hooks/usePaging";
import modulos from "../../mocks/modulos";
import { fetchRegiones } from "../../services/regionServices";
import { fetchSucursales } from "../../services/sucursalServices";
import { fetchPiAsignable } from "../../services/ticketingServices";
import { retriveRegionSucursalOptions } from "../../utils/retriveRegionSucursalOptions";
import { downloadNotasDePedido, exportarHistoricoNotasDePedido, exportAvisos, fetchNotasDePedido, getNotasDePedidoCategory } from "../../services/notasDePedidoServices";
import { exportOrdenesDeVenta } from "../../services/ordenDeVentaServices";
import NuevaNotaFormModal from "./NuevaNP/NuevaNotaFormModal";
// import PopupResposable from "./popupResposable";
import {
  getColorByEstado,
  getTextByEstado,
  getSLAColor,
  calcularDiasHabiles,
  configurarServicioParaTabla,
  initializeHolidays,
  getMetaServicios,
  addTransparency,
  getSiglaServicio,
  getStylesByOrigen,
  getSourcerName,
} from "./utils";
import { customActionsLabels, tableCustomStylesNP } from "../../ui/table";
import { ButtonPrimary, StyledSpinnerButton, CustomDropdown, ToggleButton, SimpleButton } from "../../ui/buttons";
import { KPIcard, IconKpi, ContentKpi } from "../../ui/kpis";
import { CustomLabel } from "../../ui/labels";
import { fetchServicios } from "../../services/servicioServices";
import { getServicioToShow } from "../NotasDePedidoDetail/detail";
import KpiCardNP from "../../components/kpiCard/KpiCardNP";
import SelectV2 from "../../components/SelectV2";

export const RedSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#F0292A",
    "&:hover": {
      backgroundColor: alpha("#F0292A", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#F0292A",
  },
}));

export const ActionLabel = styled(FormControlLabel)(() => ({
  "& .MuiFormControlLabel-label": {
    fontFamily: "Nunito",
    fontSize: "15px",
  },
}));

const estadosToggleOptions = [
  { value: "12", label: "Base Preventivas" },
  { value: "10", label: "Preventivas" },
  { value: "6", label: "Anuladas" },
  { value: "7", label: "Canceladas" },
  { value: "9", label: "Pre Canceladas" },
];

// Esta constante controla la cantidad de notas de pedido que se pueden exportar sin disparar el toast de error
const LIMIT_OF_NOTAS_FOR_EXPORT = 3000;

const NotasDePedido = ({ history, location }) => {
  const { currentUser, haveSucursalesAccess } = useAuth();
  const isAdmin = currentUser.haveAdminAccess(modulos.NOTAS_DE_PEDIDO);
  const isAudit = currentUser.haveAuditAccess(modulos.NOTAS_DE_PEDIDO);
  const { searchBarText } = useSearchBar();
  const [recruiter, isLoadingRecruiter] = useFetcher(fetchPiAsignable, undefined, "allfetchPiAsignable");
  const [regiones, isLoadingRegiones] = useFetcher(fetchRegiones, undefined, "fetchRegiones");
  const [sucursales, isLoadingSucursales] = useFetcher(fetchSucursales, undefined, "fetchSucursales");
  const [categories, isLoadingCategories] = useFetcher(getNotasDePedidoCategory, undefined, "getNotasDePedidoCategory");
  const pagingController = usePaging(fetchNotasDePedido);
  const [nuevaNotaForm, setNuevaNotaForm] = useState(false);
  const [checkedPricing, setCheckedPricing] = useState(false);
  const [activedFilters, setActivedFilters] = useState(0);
  const [estadosCat, setEstadosCat] = useState([]);
  const [metaServicio, setMetaServicio] = useState("");
  const [isCentralizer, setIsCentralizer] = useState(false);
  const [renderYearContent, setRenderYearContent] = useState(false);
  const [renderQuarterContent, setRenderQuarterContent] = useState(false);
  const [renderMonthContent, setRenderMonthContent] = useState(false);
  const locale = configDatePickerLenguage();
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [servicios, isLoadingServicios] = useFetcher(fetchServicios, undefined, "fetchServicios");
  const params = location.search || new URLSearchParams();

  const reloadNotas = () => {
    pagingController.reloadData(history.location);
  };

  const activeFilterKeys = useMemo(() => {
    const keys = [];

    const filtroClaves = ["region", "servicio", "sucursal", "sourcer", "recruiter", "startDate", "endDate", "businessLine"];

    filtroClaves.forEach((clave) => {
      const regex = new RegExp(`${clave}=([^&]+)`);
      if (regex.test(params)) {
        keys.push(clave);
      }
    });

    return keys;
  }, [params]);

  // configura los params cuando se elige año, trimestre o mes
  useEffect(() => {
    // Inicializa el rango de fechas desde la query al cargar la página
    if (pagingController.query && pagingController.query.startDate && pagingController.query.endDate) {
      const start = moment(pagingController.query.startDate, "DD/MM/YY").toDate();
      const end = moment(pagingController.query.endDate, "DD/MM/YY").toDate();
      setDateRange([start, end]);
      pagingController.setFilterValue({ startDate: start, endDate: end });
    }
  }, []);

  useEffect(() => {
    // Actualiza los filtros y recarga los datos cuando cambian las fechas
    if (startDate && endDate) {
      pagingController.setFilterValue({ startDate, endDate });
      pagingController.reloadData(history.location);
    }
  }, [startDate, endDate]); // Se ejecuta solo cuando cambian las fechas

  const handleDatesChange = (values) => {
    // Maneja el cambio de fechas desde el selector
    if (!values) {
      setDateRange([null, null]);
      pagingController.setFilterValue({ startDate: null, endDate: null });
    } else {
      const start = moment(values);
      let end;
      if (renderYearContent) {
        end = new Date(moment(values).add(1, "years").subtract(1, "days"));
      } else if (renderQuarterContent) {
        end = new Date(moment(values).add(1, "quarter").subtract(1, "days"));
      } else if (renderMonthContent) {
        end = new Date(moment(values).add(1, "months").subtract(1, "days"));
      } else {
        [, end] = values;
      }
      setDateRange([start, end]);
    }
  };

  // formatea el valor del rango de fechas
  const getDataRangeValue = (inputStartDate, inputEndDate) => {
    const start = inputStartDate ? moment(inputStartDate).format("DD/MM/YY") : "";
    const end = inputEndDate ? moment(inputEndDate).format("DD/MM/YY") : "";
    return `${start} - ${end}`;
  };

  const estados = categories && categories.estadoNP;
  const businessLineEnum = categories && categories.businessLine;

  estadosCat.sort((a, b) => {
    const order = "123 11 48567";
    return order.indexOf(a.id) - order.indexOf(b.id);
  });

  // se elimina la region CASA CENTRAL por defecto de las regiones
  const regionesFiltered = regiones.filter((r) => r.title !== "CASA CENTRAL");

  // se pasa un array vacio para eliminar del select las sucursales de casa central
  const casasCentralesVacio = [];

  // solo se muestran las sucursales asignadas para el usuario member
  const sucursalesAsignadas = currentUser.user && currentUser.user.sucursalesAsignadas.map((s) => s.itemId);
  const filteredSucursales = sucursales.filter((s) => sucursalesAsignadas.includes(s.itemId));

  useEffect(() => {
    initializeHolidays();
  }, []);

  // se obtienen los servicios asignados al PI x metadata de los
  // permisos del user y se configura el filtro para mostrar las notas correspondientes
  useEffect(() => {
    async function getServicioFilter() {
      // cambiando logica para filtrar permisos por servicios en lugar de puestos
      const userServicesMeta = await currentUser.getMetadata(modulos.NOTAS_DE_PEDIDO, "servicio");
      const userServices = getMetaServicios(userServicesMeta);

      const isCentralizerMeta = await currentUser.getMetadata(modulos.NOTAS_DE_PEDIDO, "centralizador");

      setIsCentralizer(isCentralizerMeta);
      setMetaServicio(userServices);
    }
    getServicioFilter();
    if (isAdmin) {
      pagingController.setFilterValue({ user: "admin" });
    }
    if (isAudit) {
      pagingController.setFilterValue({ user: "auditor" });
    }
  }, [currentUser]);

  useEffect(() => {
    pagingController.setFilterValue({ query: searchBarText });
  }, [searchBarText]);

  useEffect(() => {
    if (categories.estadoNP) {
      setEstadosCat(categories.estadoNP.type);
    }
  });

  useEffect(() => {
    if (pagingController.query && pagingController.query.origen && pagingController.query.origen === "2") {
      setCheckedPricing(true);
    }
  }, [pagingController.query]);

  // toggle de notas pricing
  const handlePricingFilter = () => {
    setCheckedPricing(!checkedPricing);
    if (!checkedPricing) {
      pagingController.setFilterValue({ origen: "2" });
    } else {
      pagingController.setFilterValue({ origen: null });
    }
  };

  // BOTON EXPORTAR Historico Notas de pedido
  const exportHistoricoNP = async () => {
    toast.success("Su solicitud de exportación está siendo procesada");
    try {
      const response = await exportarHistoricoNotasDePedido(location.search);
      if (response && response.message && response.message === "Tarea encolada, se enviará el email al finalizar") {
        toast.success("Tarea encolada, se enviará el email al finalizar");
      } else {
        toast.error("Ha ocurrido un error, inténtelo nuevamente más tarde");
      }
    } catch (error) {
      toast.error("Ha ocurrido un error, inténtelo nuevamente más tarde");
    }
  };

  // BOTON EXPORTAR Notas de pedido
  const downloadNPCSV = async () => {
    if (pagingController.totalRows > LIMIT_OF_NOTAS_FOR_EXPORT) {
      toast.error("Máximo 3.000 registros. Aplicar filtros.");
      return;
    }
    toast.success("Su solicitud de exportación está siendo procesada");
    const blob = await downloadNotasDePedido(location.search);
    const link = document.createElement("a");
    const url = window.URL.createObjectURL(blob);
    const filename = `Notas de pedido-${moment().format(humanDateFormat)}.csv`;
    link.href = url;
    link.setAttribute("download", filename);
    link.click();
    window.URL.revokeObjectURL(url);
  };

  // BOTON EXPORTAR Ordenes de venta
  const downloadOVCSV = async () => {
    toast.success("Su solicitud de exportación está siendo procesada");
    const blob = await exportOrdenesDeVenta(location.search);
    const link = document.createElement("a");
    const url = window.URL.createObjectURL(blob);
    const filename = `Ordenes de venta-${moment().format(humanDateFormat)}.csv`;
    link.href = url;
    link.setAttribute("download", filename);
    link.click();
    window.URL.revokeObjectURL(url);
  };

  // BOTON EXPORTAR avisos
  const downloadAvisosCSV = async () => {
    toast.success("Su solicitud de exportación está siendo procesada");
    const blob = await exportAvisos(location.search);
    const link = document.createElement("a");
    const url = window.URL.createObjectURL(blob);
    const filename = `Avisos-${moment().format(humanDateFormat)}.csv`;
    link.href = url;
    link.setAttribute("download", filename);
    link.click();
    window.URL.revokeObjectURL(url);
  };

  const helperRegionSucursal = retriveRegionSucursalOptions(
    pagingController.query.region,
    pagingController.query.sucursal,
    regionesFiltered,
    isAdmin ? sucursales : filteredSucursales,
    casasCentralesVacio,
    isLoadingRegiones || isLoadingSucursales,
    haveSucursalesAccess(modulos.NOTAS_DE_PEDIDO),
    currentUser.user
  );

  const sucursalesOptions = helperRegionSucursal.casasAndSucusOptions.filter((sucursal) => {
    return sucursal.estado === 1;
  });

  let recruiterFilteres = recruiter;
  if (helperRegionSucursal.selectedRegion || helperRegionSucursal.selectedSucursal) {
    recruiterFilteres = recruiter.filter((pi) => {
      const sucursalesPi = (pi.CasaCentral || []).concat(pi.SucursalesAsignadas || []);
      return (
        (!helperRegionSucursal.selectedRegion || sucursalesPi.map((sucursal) => sucursal.region2).includes(helperRegionSucursal.selectedRegion)) &&
        (!helperRegionSucursal.selectedSucursal || sucursalesPi.map((sucursal) => sucursal.itemId).includes(helperRegionSucursal.selectedSucursal))
      );
    });
  }

  // Se comenta este filtro por ser iguales las opciones para select de RECRUITER y SOURCER
  // const sourcerFilteres = recruiterFilteres.filter(
  //   (pi) => (pi.posicionCat && pi.posicionCat.text === "SOURCER") ||
  //   (pi.posicionCat && pi.posicionCat.text === "RECRUITER")
  // );

  // filtra por Pis con puesto RECRUITER, SOURCER, CONSULTANT, ONSITE y ONSITE C para mostrarlos en el select
  recruiterFilteres = recruiterFilteres.filter(
    (pi) =>
      (pi.posicionCat && pi.posicionCat.text === "RECRUITER") ||
      (pi.posicionCat && pi.posicionCat.text === "SOURCER") ||
      (pi.posicionCat && pi.posicionCat.text === "ONSITE C") ||
      (pi.posicionCat && pi.posicionCat.text === "ONSITE") ||
      (pi.posicionCat && pi.posicionCat.text === "CONSULTANT")
  );

  // Actualmente las opciones son iguales
  const sourcerFilteres = recruiterFilteres;

  const recruiterOptions = recruiterFilteres
    .map((pi) => {
      return { label: pi.nombreApellido, value: pi.itemId };
    })
    .sort((a, b) => (a.label > b.label ? 1 : -1));

  const sourcerOptions = sourcerFilteres
    .map((pi) => {
      return { label: pi.nombreApellido, value: pi.itemId };
    })
    .sort((a, b) => (a.label > b.label ? 1 : -1));

  const userServicesList = metaServicio && metaServicio.split(", ");
  const userServicesNumberList = userServicesList && userServicesList.map(Number);
  // Opciones para select de servicios
  const serviciosOptions = servicios
    ? servicios
        .map((e) => {
          return { label: getSiglaServicio(e.id, e.text), value: e.id };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const serviciosOptionsFiltered = serviciosOptions.filter((servicio) => {
    // Si no hay lista de servicios habilitados, mostramos solo los hardcodeados (1, 3, 5)
    if (!userServicesNumberList) {
      return [1, 3, 5].includes(servicio.value);
    }

    // Mostrar solo si:
    // - está en la lista de servicios habilitados
    return userServicesNumberList.includes(servicio.value);
  });

  if (activedFilters < 0) {
    setActivedFilters(0);
  }

  const businessLineOptions =
    businessLineEnum && businessLineEnum.type && businessLineEnum.type.length > 0
      ? businessLineEnum.type
          .map((e) => {
            return { label: e.text, value: e.id };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  const handleReactSelectChange = (selected, options) => {
    if ((options.action === "select-option" && options.option === undefined) || (options.action === "clear" && options.removedValues.length === 1)) {
      const newState = { [options.name]: selected ? selected.value : null };
      if (newState.region) {
        newState.sucursal = null;
      }
      pagingController.setFilterValue(newState);
    } else {
      const newState = { [options.name]: selected[0] ? selected.map((item) => item.value).join(",") : null };
      if (newState.region) {
        newState.sucursal = null;
      }
      pagingController.setFilterValue(newState);
    }
  };

  const handleFilterStatus = (estado) => {
    const currentEstado = pagingController.query.estado;
    const arrayEstado = currentEstado ? currentEstado.split(",") : [];
    const objEstado = estadosCat.find((objeto) => objeto.id === estado);
    const estadoId = objEstado ? objEstado.id : null;

    if (currentEstado) {
      // Verificar si el estado actual ya está presente en la lista de estados seleccionados
      const idString = JSON.stringify(estadoId);
      const isEstadoSelected = arrayEstado.includes(idString);

      // Si el estado ya está seleccionado, eliminarlo de la lista
      if (isEstadoSelected) {
        const updatedEstado = arrayEstado.filter((e) => e !== idString);

        if (updatedEstado.length === 0) {
          pagingController.setFilterValue({ estado: null });
        } else {
          pagingController.setFilterValue({ estado: updatedEstado });
        }
      }
      // Si el estado no está seleccionado, agregarlo a la lista
      else {
        const updatedEstado = [...arrayEstado, estadoId];
        pagingController.setFilterValue({ estado: updatedEstado });
      }
    } else {
      // Si no hay estados seleccionados lo agrega directamente
      pagingController.setFilterValue({ estado: estadoId });
    }
  };

  const handleFilterConAviso = () => {
    if (pagingController.query.conaviso) {
      pagingController.setFilterValue({ conaviso: null, sinaviso: null });
    }
    pagingController.setFilterValue({ conaviso: true, sinaviso: null });
  };

  const handleFilterSinAviso = () => {
    if (pagingController.query.sinaviso) {
      pagingController.setFilterValue({ conaviso: null, sinaviso: null });
    }
    pagingController.setFilterValue({ conaviso: null, sinaviso: true });
  };

  const handleFilterHUB = () => {
    if (pagingController.query.hubServicios) {
      pagingController.setFilterValue({ hubServicios: null });
    }
    pagingController.setFilterValue({ hubServicios: true });
  };

  const handleNotaClicked = (row) => {
    history.push({
      pathname: `/notasDePedido/${row.id}/detail/${location.search}`,
      state: { nota: row, from: location },
    });
  };

  // se configura el date Picker para mostrar año, trimesre, mes o dia
  const dateRangeShow = (type) => {
    if (type === "day") {
      setRenderYearContent(false);
      setRenderQuarterContent(false);
      setRenderMonthContent(false);
    } else if (type === "month") {
      setRenderMonthContent(true);
      setRenderYearContent(false);
      setRenderQuarterContent(false);
    } else if (type === "quarter") {
      setRenderQuarterContent(true);
      setRenderYearContent(false);
      setRenderMonthContent(false);
    } else if (type === "year") {
      setRenderYearContent(true);
      setRenderQuarterContent(false);
      setRenderMonthContent(false);
    }
    pagingController.setFilterValue({ startDate: null, endDate: null });
  };

  // calculo para KPI porcentaje
  const { cubiertasTotales, totalActivas, porcentajeCubiertas } = useMemo(() => {
    const stats = pagingController.coberturaStats;

    if (!stats) {
      return {
        cubiertasTotales: 0,
        totalActivas: 0,
        porcentajeCubiertas: 0,
      };
    }

    const cubierta = typeof stats.Cubierta === "number" ? stats.Cubierta : 0;
    const parcialmenteCubierta = typeof stats["Parcialmente Cubierta"] === "number" ? stats["Parcialmente Cubierta"] : 0;
    const anulada = typeof stats.Anulada === "number" ? stats.Anulada : 0;
    const preCancelada = typeof stats["Pre Cancelada"] === "number" ? stats["Pre Cancelada"] : 0;
    const cancelada = typeof stats.Cancelada === "number" ? stats.Cancelada : 0;
    const preventiva = typeof stats.Preventiva === "number" ? stats.Preventiva : 0;
    const basePreventiva = typeof stats["Base Preventiva"] === "number" ? stats["Base Preventiva"] : 0;
    const total = typeof stats.Total === "number" ? stats.Total : 0;

    const totales = cubierta + parcialmenteCubierta;
    const activas = total - anulada - cancelada - preCancelada - preventiva - basePreventiva;

    const porcentaje = activas > 0 ? (totales / activas) * 100 : 0;

    return {
      cubiertasTotales: totales,
      totalActivas: activas,
      porcentajeCubiertas: porcentaje,
    };
  }, [pagingController.statusStats]);

  const { conAviso, totales, porcentajeConAviso } = useMemo(() => {
    const stats = pagingController.statusStats;
    if (!stats) {
      return {
        conAviso: 0,
        totales: 0,
        porcentajeConAviso: 0,
      };
    }

    const npConAviso = typeof stats.totalNPConAvisos === "number" ? stats.totalNPConAvisos : 0;
    const npTotales = typeof stats.Total === "number" ? stats.Total : 0;

    const porcentajeNPConAviso = npTotales > 0 ? (npConAviso / npTotales) * 100 : 0;

    return {
      conAviso: npConAviso,
      totales: npTotales,
      porcentajeConAviso: porcentajeNPConAviso,
    };
  }, [pagingController.statusStats]);

  return (
    <>
      {nuevaNotaForm && (
        <NuevaNotaFormModal
          history={history}
          isOpen={nuevaNotaForm}
          reloadNotas={reloadNotas}
          metaServicios={metaServicio}
          isCentralizer={isCentralizer}
          toggle={() => setNuevaNotaForm(!nuevaNotaForm)}
        />
      )}
      <Helmet>
        <title>PIN - Notas de Pedido</title>
      </Helmet>
      <ShowSearchBar defaultValue={pagingController.query.query} />
      <div style={{ display: "flex", alignItems: "center", position: "absolute", right: "30px", zIndex: "1", marginTop: "30px" }}>
        <ButtonPrimary type="button" onClick={() => setNuevaNotaForm(!nuevaNotaForm)}>
          Crear Nota de Pedido
          <span className="ml-2 d-flex align-items-center">
            <Plus size={16} strokeWidth={2.25} />
          </span>
        </ButtonPrimary>
      </div>
      <Breadcrumb title="Notas de Pedido" parent="Sistema de Notas de Pedido" backButton={pagingController.query.mode === "creador"} />
      <BlurSpinner isLoading={pagingController.isLoading || isLoadingRegiones || isLoadingSucursales}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="d-flex align-items-center mb-3">
                <CustomDropdown backgroundColor="#fff" box-shadow="0px 0px 4px 0px #00000040" padding="20px" toggleMaxWidth="130px">
                  <Dropdown>
                    <Dropdown.Toggle
                      className={`dropdown-toggle white-black px-2 flex align-items-center justify-content-between ${
                        activeFilterKeys && activeFilterKeys.length > 0 ? "filters-active" : ""
                      }`}
                      style={{ width: "200px" }}
                      id="dropdown-basic-filter"
                    >
                      <div className="d-flex align-items-center">
                        <SlidersHorizontal size={18} className="mr-2" />
                        Filtros {activeFilterKeys && activeFilterKeys.length > 0 && `(${activeFilterKeys.length})`}
                      </div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ backgroundColor: "#fff !important" }}>
                      <div className="d-flex justify-content-end">
                        <SimpleButton
                          type="button"
                          onClick={() => {
                            const filtersToReset = activeFilterKeys.reduce((acc, key) => {
                              acc[key] = null;
                              return acc;
                            }, {});
                            pagingController.setFilterValue(filtersToReset);
                          }}
                        >
                          Borrar filtros
                        </SimpleButton>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "1rem",
                        }}
                      >
                        {/* filtro business line */}
                        <CustomLabel htmlFor="businessLine" className="pt-0 w-100">
                          Business Line
                          <SelectV2
                            isMulti
                            id="businessLine"
                            name="businessLine"
                            onChange={handleReactSelectChange}
                            value={
                              businessLineOptions.filter((option) =>
                                pagingController.query.businessLine ? pagingController.query.businessLine.includes(option.value) : ""
                              ) || null
                            }
                            placeholder="Seleccionar..."
                            isClearable
                            isLoading={isLoadingCategories}
                            isDisabled={isLoadingCategories}
                            options={businessLineOptions}
                          />
                        </CustomLabel>

                        {/* filtro recruiter */}
                        <CustomLabel htmlFor="recruiter" className="pt-0 w-100">
                          Recruiter
                          <SelectV2
                            id="recruiter"
                            name="recruiter"
                            onChange={handleReactSelectChange}
                            value={recruiterOptions.find((option) => (pagingController.query.recruiter ? pagingController.query.recruiter.includes(option.value) : null))}
                            isClearable
                            isLoading={isLoadingRecruiter}
                            disabled={isLoadingRecruiter}
                            options={recruiterOptions}
                          />
                        </CustomLabel>

                        {/* filtro region */}
                        <CustomLabel htmlFor="region" className="pt-0 w-100">
                          Region
                          <SelectV2
                            id="region"
                            name="region"
                            onChange={handleReactSelectChange}
                            value={
                              helperRegionSucursal.regionesOptions.length === 1
                                ? helperRegionSucursal.regionesOptions
                                : helperRegionSucursal.regionesOptions.find((option) => option.value === helperRegionSucursal.selectedRegion) || null
                            }
                            isClearable
                            isLoading={isLoadingRegiones}
                            isDisabled={isLoadingRegiones || helperRegionSucursal.disableRegionSucursal || helperRegionSucursal.regionesOptions.length === 1}
                            options={helperRegionSucursal.regionesOptions}
                          />
                        </CustomLabel>

                        {/* filtro sucursal */}
                        <CustomLabel htmlFor="sucursal" className="pt-0 w-100">
                          Sucursal
                          <SelectV2
                            // cuando solo hay una opcion de sucursal, el select ne es milti.
                            // eslint-disable-next-line no-unneeded-ternary
                            isMulti={helperRegionSucursal.casasAndSucusOptions.length === 1 ? false : true}
                            id="sucursal"
                            name="sucursal"
                            onChange={handleReactSelectChange}
                            value={
                              helperRegionSucursal.casasAndSucusOptions.length === 1
                                ? helperRegionSucursal.casasAndSucusOptions
                                : (pagingController.query.sucursal &&
                                    helperRegionSucursal.casasAndSucusOptions.filter((option) => pagingController.query.sucursal.includes(String(option.value)))) ||
                                  null
                            }
                            isClearable
                            isLoading={isLoadingSucursales}
                            isDisabled={isLoadingSucursales || helperRegionSucursal.disableRegionSucursal || helperRegionSucursal.casasAndSucusOptions.length === 1}
                            options={sucursalesOptions}
                          />
                        </CustomLabel>

                        {/* filtro sourcer */}
                        <CustomLabel htmlFor="sourcer" className="pt-0 w-100">
                          Sourcer
                          <SelectV2
                            id="sourcer"
                            name="sourcer"
                            onChange={handleReactSelectChange}
                            value={sourcerOptions.find((option) => (pagingController.query.sourcer ? pagingController.query.sourcer.includes(option.value) : null))}
                            isClearable
                            isLoading={isLoadingRecruiter}
                            disabled={isLoadingRecruiter}
                            options={sourcerOptions}
                          />
                        </CustomLabel>

                        {/* filtro servicios */}
                        {(metaServicio && userServicesList && userServicesList.length > 1) || (!metaServicio && isAdmin) ? (
                          <CustomLabel htmlFor="servicio" className="pt-0 w-100">
                            Servicios
                            <SelectV2
                              isMulti
                              id="servicio"
                              name="servicio"
                              onChange={handleReactSelectChange}
                              value={
                                serviciosOptionsFiltered.filter((option) =>
                                  pagingController.query.servicio ? pagingController.query.servicio.includes(option.value) : ""
                                ) || null
                              }
                              placeholder="Seleccionar..."
                              isClearable
                              isLoading={isLoadingServicios}
                              isDisabled={isLoadingServicios}
                              options={serviciosOptionsFiltered}
                            />
                          </CustomLabel>
                        ) : null}

                        {/* filtro rango de fechas */}
                        <CustomLabel htmlFor="fecha">
                          Rango de fechas
                          <StylesDatePicker twoMonths height="32px" right="0px" className="w-100">
                            <DatePicker
                              placeholderText="Todo"
                              locale={locale}
                              id="fecha"
                              className="digits date-input"
                              selectsRange={!renderYearContent && !renderQuarterContent && !renderMonthContent}
                              startDate={pagingController.query.startDate || startDate}
                              endDate={pagingController.query.endDate || endDate}
                              onChange={(update) => {
                                if (renderMonthContent || renderQuarterContent || renderYearContent) {
                                  handleDatesChange(update);
                                } else {
                                  update ? setDateRange(update) : pagingController.setFilterValue({ startDate: null, endDate: null });
                                }
                              }}
                              value={
                                pagingController.query.startDate
                                  ? getDataRangeValue(pagingController.query.startDate || startDate, pagingController.query.endDate || endDate)
                                  : null
                              }
                              selected={pagingController.query.startDate ? pagingController.query.startDate : null}
                              monthsShown={!(renderYearContent || renderQuarterContent || renderMonthContent) ? 2 : 1}
                              showYearPicker={renderYearContent}
                              showQuarterYearPicker={renderQuarterContent}
                              showMonthYearPicker={renderMonthContent}
                              isClearable
                              clearButtonClassName="clear-button"
                              autoComplete="off"
                            >
                              <div className="buttons mx-4">
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <ButtonPrimary style={{ height: "30px" }} fontSize="14px" onClick={() => dateRangeShow("day")}>
                                    Días
                                  </ButtonPrimary>
                                  <ButtonPrimary style={{ height: "30px" }} fontSize="14px" onClick={() => dateRangeShow("month")}>
                                    Meses
                                  </ButtonPrimary>
                                  <ButtonPrimary style={{ height: "30px" }} fontSize="14px" onClick={() => dateRangeShow("quarter")}>
                                    Trimestre
                                  </ButtonPrimary>
                                  <ButtonPrimary style={{ height: "30px" }} fontSize="14px" onClick={() => dateRangeShow("year")}>
                                    Años
                                  </ButtonPrimary>
                                </div>
                              </div>
                            </DatePicker>
                          </StylesDatePicker>
                        </CustomLabel>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </CustomDropdown>
                {/* KPI con aviso/ sin aviso */}
                <div className="px-0 mx-4 d-flex align-items-center">
                  <ToggleButton onClick={handleFilterConAviso} isSelected={pagingController.query.conaviso} marginRight="2px">
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minWidth: "160px" }}>
                      <Bell size={18} />
                      <p className="m-0 px-1" style={{ whiteSpace: "nowrap" }}>
                        Con Aviso
                      </p>
                      <div className="d-flex align-items-end justify-content-start">
                        {pagingController.totalRows ? (
                          <>
                            <p className="pl-1 m-0" style={{ fontWeight: "bold" }}>{`${
                              pagingController && pagingController.statusStats && pagingController.statusStats.ConAvisos
                            }/${pagingController && pagingController.statusStats && pagingController.statusStats.QNPActivas}`}</p>
                          </>
                        ) : (
                          <>
                            <p className="pl-1 m-0">-</p>
                          </>
                        )}
                      </div>
                    </div>
                  </ToggleButton>
                  <ToggleButton onClick={handleFilterSinAviso} isSelected={pagingController.query.sinaviso} marginRight="2px">
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minWidth: "160px" }}>
                      <BellOff size={18} />
                      <p className="m-0 px-1" style={{ whiteSpace: "nowrap" }}>
                        Sin Aviso
                      </p>
                      <div className="d-flex align-items-end justify-content-start">
                        {pagingController.totalRows ? (
                          <>
                            <p className="pl-1 m-0" style={{ fontWeight: "bold" }}>{`${
                              pagingController && pagingController.statusStats && pagingController.statusStats.SinAvisos
                            }/${pagingController && pagingController.statusStats && pagingController.statusStats.QNPActivas}`}</p>
                          </>
                        ) : (
                          <>
                            <p className="pl-1 m-0">-</p>
                          </>
                        )}
                      </div>
                    </div>
                  </ToggleButton>
                  <ToggleButton onClick={handleFilterHUB} isSelected={pagingController.query.hubServicios} marginRight="2px">
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minWidth: "160px" }}>
                      <Focus size={18} />
                      <p className="m-0 px-1" style={{ whiteSpace: "nowrap" }}>
                        Centralizado HUB
                      </p>
                    </div>
                  </ToggleButton>
                </div>
              </div>
              {isLoadingCategories ? (
                <></>
              ) : (
                <>
                  {/* ----------------- CARDS DE STATUS ---------------- */}
                  <div
                    className="d-flex flex-wrap"
                    style={{
                      gap: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    {estadosCat && pagingController.statusStats
                      ? estadosCat.map((estado) => {
                          const statusDef = {
                            id: estado.id,
                            text: estado.text,
                            color: getColorByEstado(estado.id),
                          };
                          const value = { count: pagingController.statusStats[estado.text] || 0 };
                          return (
                            NotasDePedidoKpiIcons[estado.id] && (
                              <div
                                key={estado.id}
                                style={{
                                  flex: "1 1 200px",
                                  maxWidth: "250px",
                                }}
                              >
                                <KpiCardNP
                                  statusDef={statusDef}
                                  icon={NotasDePedidoKpiIcons[estado.id]}
                                  value={value}
                                  total={pagingController.statusStats.Total || 0}
                                  onClick={handleFilterStatus}
                                  selected={pagingController.query.estado ? pagingController.query.estado.split(",").map(Number).includes(estado.id) : false}
                                />
                              </div>
                            )
                          );
                        })
                      : null}
                  </div>

                  {/* -------------------------TARJETAS ALARGADAS KPI------------------------------ */}
                  <div className="d-flex w-100 mb-3" style={{ justifyContent: "start", gap: "8px" }}>
                    <KPIcard className="mb-0" borderRadius="4px" style={{ height: "42px" }}>
                      <div className="d-flex align-items-center justify-content-between px-3 w-100">
                        <IconKpi svgWidth="20px" svgHeight="20px">
                          <Clock9 color="#F0292A" strokeWidth={2.5} size={18} />
                        </IconKpi>
                        <div className="d-flex justify-content-between w-100 mx-2">
                          <ContentKpi className="flex-row">
                            <h4>Tiempo de derivación</h4>
                            {pagingController.timeStats && pagingController.timeStats.tiempo_derivacion ? (
                              <>
                                <h4 className="pl-1" style={{ fontWeight: 700 }}>
                                  {parseFloat(pagingController.timeStats.tiempo_derivacion).toFixed(2)}
                                </h4>
                              </>
                            ) : (
                              <h4 className="pl-1" style={{ fontWeight: 700 }}>
                                -
                              </h4>
                            )}
                          </ContentKpi>
                          <ContentKpi className="flex-row">
                            <h4>Target</h4>
                            <h4 className="pl-1" style={{ fontWeight: 700 }}>
                              10 días
                            </h4>
                          </ContentKpi>
                        </div>
                      </div>
                    </KPIcard>

                    <KPIcard className="mb-0" borderRadius="4px" style={{ height: "42px" }}>
                      <div className="d-flex align-items-center justify-content-between px-3 w-100">
                        <IconKpi svgWidth="20px" svgHeight="20px">
                          <CircleCheck color="#F0292A" strokeWidth={2.5} size={18} />
                        </IconKpi>
                        <div className="d-flex justify-content-between w-100 mx-2">
                          <ContentKpi className="flex-row">
                            <h4>Tiempo de cobertura</h4>

                            {pagingController.timeStats && pagingController.timeStats.tiempo_cobertura ? (
                              <>
                                <h4 className="pl-1" style={{ fontWeight: 700 }}>
                                  {parseFloat(pagingController.timeStats.tiempo_cobertura).toFixed(2)}
                                </h4>
                              </>
                            ) : (
                              <h4 style={{ fontWeight: 700 }}>-</h4>
                            )}
                          </ContentKpi>
                          <ContentKpi className="flex-row">
                            <h4>Target</h4>
                            <h4 className="pl-1" style={{ fontWeight: 700 }}>
                              30 días
                            </h4>
                          </ContentKpi>
                        </div>
                      </div>
                    </KPIcard>

                    <KPIcard className="mb-0" borderRadius="4px" style={{ height: "42px" }}>
                      <div className="d-flex align-items-center justify-content-between px-3 w-100">
                        <IconKpi svgWidth="20px" svgHeight="20px">
                          <CirclePercent color="#F0292A" strokeWidth={2.5} size={18} />
                        </IconKpi>
                        <div className="d-flex justify-content-between w-100 mx-2">
                          <ContentKpi className="flex-row">
                            <h4>Cobertura</h4>

                            {pagingController.statusStats ? (
                              <>
                                <h4 className="pl-1" style={{ fontWeight: 700 }}>
                                  {pagingController.statusStats ? `${cubiertasTotales}/${totalActivas}` : "-"}
                                </h4>
                              </>
                            ) : (
                              <h4 style={{ fontWeight: 700 }}>-</h4>
                            )}
                          </ContentKpi>
                          <ContentKpi className="flex-row">
                            {porcentajeCubiertas ? (
                              <h4 className="pl-1" style={{ fontWeight: 700 }}>
                                {Math.round(porcentajeCubiertas)}%
                              </h4>
                            ) : (
                              <h4 className="pl-1" style={{ fontWeight: 700 }}>
                                -
                              </h4>
                            )}
                          </ContentKpi>
                        </div>
                      </div>
                    </KPIcard>

                    <KPIcard className="mb-0" borderRadius="4px" style={{ height: "42px" }}>
                      <div className="d-flex align-items-center justify-content-between px-3 w-100">
                        <IconKpi svgWidth="20px" svgHeight="20px">
                          <SquarePercent color="#F0292A" strokeWidth={2.5} size={18} />
                        </IconKpi>
                        <div className="d-flex justify-content-between w-100 mx-2">
                          <ContentKpi className="flex-row">
                            <h4>NP Con Avisos</h4>

                            {pagingController.statusStats ? (
                              <>
                                <h4 className="pl-1" style={{ fontWeight: 700 }}>
                                  {pagingController.statusStats ? `${conAviso}/${totales}` : "-"}
                                </h4>
                              </>
                            ) : (
                              <h4 style={{ fontWeight: 700 }}>-</h4>
                            )}
                          </ContentKpi>
                          <ContentKpi className="flex-row">
                            {porcentajeCubiertas ? (
                              <h4 className="pl-1" style={{ fontWeight: 700 }}>
                                {Math.round(porcentajeConAviso)}%
                              </h4>
                            ) : (
                              <h4 className="pl-1" style={{ fontWeight: 700 }}>
                                -
                              </h4>
                            )}
                          </ContentKpi>
                        </div>
                      </div>
                    </KPIcard>
                  </div>
                </>
              )}

              <div className="table-responsive support-table border">
                <DataTable
                  title="Notas de Pedido"
                  paginationComponentOptions={{ rowsPerPageText: "Notas por pagina", rangeSeparatorText: "De", selectAllRowsItemText: "Todos" }}
                  noDataComponent={
                    <div className="p-3">
                      <b>No se encontraron Notas de Pedido</b>
                    </div>
                  }
                  striped
                  pagination
                  sortServer
                  paginationServer
                  actions={[
                    <div style={{ width: "100%", height: "40px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <div style={{ position: "fixed", zIndex: 1, right: "90px" }}>
                        <div className="d-flex justify-content-between align-items-center w-100">
                          <div className="mx-3" style={{ width: "250px" }}>
                            <SelectV2
                              isMulti
                              id="estado"
                              name="estado"
                              value={
                                pagingController.query && pagingController.query.estado
                                  ? estadosToggleOptions.filter((option) => pagingController.query.estado.split(",").includes(option.value))
                                  : null
                              }
                              onChange={handleReactSelectChange}
                              placeholder="Estado"
                              options={estadosToggleOptions}
                            />
                          </div>

                          <ActionLabel
                            control={<RedSwitch color="warning" checked={checkedPricing} onChange={handlePricingFilter} />}
                            label="Pricing"
                            style={customActionsLabels}
                          />
                        </div>
                      </div>
                    </div>,

                    // ACÁ VAN LOS BOTONES EXPORTAR --------------------------------------------
                    pagingController.totalRows > 0 && (
                      <div style={{ width: "80px", height: "40px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <div style={{ position: "fixed", zIndex: 1 }}>
                          <CustomDropdown dropdownStyles={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" }}>
                            <Dropdown>
                              <Dropdown.Toggle className="dropdown-toggle white px-2" id="dropdown-basic">
                                <Share2 size={18} />
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {isAdmin && (
                                  <StyledSpinnerButton className="w-100 mb-2" type="button" onClick={(e) => exportHistoricoNP(e.target.value)}>
                                    Exportar Historico Notas de pedido
                                  </StyledSpinnerButton>
                                )}
                                <StyledSpinnerButton className="w-100 mb-2" type="button" onClick={(e) => downloadNPCSV(e.target.value)}>
                                  Exportar Notas de pedido
                                </StyledSpinnerButton>
                                <StyledSpinnerButton className="w-100 mb-2" type="button" onClick={(e) => downloadOVCSV(e.target.value)}>
                                  Exportar Ordenes de venta
                                </StyledSpinnerButton>
                                <StyledSpinnerButton className="w-100 mb-2" type="button" onClick={(e) => downloadAvisosCSV(e.target.value)}>
                                  Exportar Reporte de Avisos
                                </StyledSpinnerButton>
                              </Dropdown.Menu>
                            </Dropdown>
                          </CustomDropdown>
                        </div>
                      </div>
                    ),
                  ]}
                  onRowClicked={handleNotaClicked}
                  data={pagingController.data}
                  onSort={pagingController.handleSortsChange}
                  paginationTotalRows={pagingController.totalRows}
                  paginationDefaultPage={parseInt(pagingController.query.page || 1, 10)}
                  onChangeRowsPerPage={pagingController.handleRecordsPerPageChange}
                  paginationPerPage={parseInt(pagingController.query.perpage || 10, 10)}
                  onChangePage={pagingController.handlePageChange}
                  customStyles={tableCustomStylesNP}
                  columns={[
                    {
                      name: "Id",
                      id: "id",
                      selector: (row) =>
                        row.id ? (
                          <div className="d-flex justify-content-between align-items-center">
                            <p className="m-0">{row.id}</p>
                            {row.origen && [1, 2, 3].includes(row.origen) && estados ? (
                              <div
                                className="ml-1"
                                style={{
                                  fontSize: "10px",
                                  ...getStylesByOrigen(row.origen),
                                  borderRadius: "5px",
                                  padding: "4px",
                                  minWidth: "40px",
                                }}
                              >
                                {estados.origen.find((o) => o.id === row.origen).text}
                              </div>
                            ) : null}
                          </div>
                        ) : null,
                      sortable: true,
                      center: true,
                      // width: "70px",
                      style: {
                        cursor: "pointer",
                        textAlign: "center",
                      },
                    },
                    {
                      name: "Sucursal",
                      selector: (row) =>
                        row.sucursal.titulo ? (
                          <>
                            <UncontrolledTooltip target={`sucursal${row.id}`}>{row.sucursal.titulo}</UncontrolledTooltip>
                            <div data-tag="allowRowEvents" id={`sucursal${row.id}`}>
                              {row.sucursal.titulo}
                            </div>
                          </>
                        ) : (
                          "-"
                        ),
                      // sortable: true,
                      // wrap: true,
                      center: true,
                      // id: "itemId",
                      style: {
                        cursor: "pointer",
                        textAlign: "center",
                      },
                    },
                    {
                      name: "Razón Social",
                      selector: (row) =>
                        row.razonSocial ? (
                          <>
                            <UncontrolledTooltip target={`razon${row.id}`}>{row.razonSocial}</UncontrolledTooltip>
                            <div data-tag="allowRowEvents" id={`razon${row.id}`}>
                              {row.razonSocial}
                            </div>
                          </>
                        ) : (
                          "-"
                        ),
                      sortable: true,
                      id: "razonSocial",
                      // wrap: true,
                      center: true,
                      style: {
                        cursor: "pointer",
                        textAlign: "center",
                        width: "115px",
                      },
                    },
                    {
                      name: "Recruiter",
                      selector: (row) =>
                        row.piRecruiter ? (
                          <>
                            <UncontrolledTooltip target={`recruiter${row.id}`}>{row.piRecruiter.nombreApellido}</UncontrolledTooltip>
                            <div data-tag="allowRowEvents" id={`recruiter${row.id}`}>
                              {row.piRecruiter.nombreApellido}
                            </div>
                          </>
                        ) : (
                          "-"
                        ),
                      sortable: true,
                      id: "recruiter",
                      center: true,
                      // wrap: true,
                      style: {
                        cursor: "pointer",
                        textAlign: "center",
                        width: "115px",
                      },
                    },
                    {
                      name: "Sourcer",
                      selector: (row) => (row.sourcer && recruiter ? getSourcerName(row.sourcer, recruiter) : "-"),
                      sortable: true,
                      id: "sourcer",
                      center: true,
                      wrap: true,
                      style: {
                        cursor: "pointer",
                        textAlign: "center",
                        width: "115px",
                      },
                    },
                    {
                      name: "Servicio",
                      selector: (row) =>
                        row.servicio ? (
                          <>
                            {row.servicio === 1 ? <UncontrolledTooltip target={`service${row.id}`}>{getServicioToShow(row.servicio, row)}</UncontrolledTooltip> : null}
                            <div data-tag="allowRowEvents" id={`service${row.id}`}>
                              {configurarServicioParaTabla(row.servicio)}
                            </div>
                          </>
                        ) : (
                          ""
                        ),
                      id: "servicio",
                      center: true,
                      wrap: true,
                      width: "95px",
                      style: {
                        textAlign: "center",
                        cursor: "pointer",
                      },
                    },
                    {
                      name: "Posición",
                      selector: (row) =>
                        row.posicion ? (
                          <>
                            <UncontrolledTooltip target={`posicion${row.id}`}>{row.posicion}</UncontrolledTooltip>
                            <div data-tag="allowRowEvents" id={`posicion${row.id}`}>
                              {row.posicion}
                            </div>
                          </>
                        ) : (
                          "-"
                        ),
                      // wrap: true,
                      sortable: true,
                      id: "posicion",
                      center: true,
                      style: {
                        cursor: "pointer",
                        textAlign: "center",
                        width: "115px",
                      },
                    },
                    {
                      name: "Cargo",
                      id: "cargo",
                      selector: (row) =>
                        row.cargo ? (
                          <>
                            <UncontrolledTooltip target={`cargo${row.id}`}>{row.cargo}</UncontrolledTooltip>
                            <div id={`cargo${row.id}`}>{row.cargo}</div>
                          </>
                        ) : (
                          "-"
                        ),
                      sortable: true,
                      center: true,
                      style: {
                        cursor: "pointer",
                        textAlign: "center",
                        width: "115px",
                      },
                    },
                    {
                      name: "QCUB/QTOT",
                      id: "vacantes",
                      selector: (row) =>
                        row.vacantes ? (
                          <div className="text-center w-auto">
                            <span
                              style={{
                                fontSize: "unset",
                              }}
                            >
                              {row.derivacionNP
                                .map((derivacion) => {
                                  return derivacion.cubiertas;
                                })
                                .reduce((a, b) => a + b, 0)}
                              /{row.vacantes}
                            </span>
                          </div>
                        ) : (
                          ""
                        ),
                      sortable: true,
                      center: true,
                      width: "140px",
                      style: {
                        cursor: "pointer",
                        textAlign: "center",
                      },
                    },
                    {
                      name: "Días abierta",
                      selector: (row) => (row.fechaAbierta ? calcularDiasHabiles(row.fechaAbierta, row.fechaCerrada || null) : "-"),
                      width: "120px !important",
                      center: true,
                      // sortable: true,
                      wrap: true,
                      style: {
                        cursor: "pointer",
                        textAlign: "center",
                      },
                    },
                    {
                      name: "SLA",
                      id: "health",
                      selector: (row) =>
                        row.health ? (
                          <div
                            data-tag="allowRowEvents"
                            className="text-center"
                            style={{ background: getSLAColor(row.health), width: "20px", height: "20px", borderRadius: "20px" }}
                          />
                        ) : (
                          <div
                            data-tag="allowRowEvents"
                            className="text-center"
                            style={{ background: "rgb(196 193 193)", width: "20px", height: "20px", borderRadius: "20px" }}
                          />
                        ),
                      width: "80px !important",
                      center: true,
                      sortable: true,
                      wrap: true,
                      style: {
                        cursor: "pointer",
                      },
                    },
                    {
                      name: "Estado",
                      id: "estado",
                      selector: (row) =>
                        row.estado ? (
                          <>
                            <div
                              data-tag="allowRowEvents"
                              className="text-center"
                              id={`estado${row.id}`}
                              style={{
                                background: `${addTransparency(getColorByEstado(row.estado), 0.2)}`,
                                color: `${getColorByEstado(row.estado)}`,
                                padding: "2px 10px",
                                borderRadius: "5px",
                                width: "100%",
                                minWidth: "80px",
                                fontSize: "12px",
                              }}
                            >
                              {getTextByEstado(row.estado, estados && estados.type)}
                            </div>
                            {row.motivo ? (
                              <UncontrolledTooltip target={`estado${row.id}`} style={{ fontSize: "12px" }}>
                                {row.motivo}
                              </UncontrolledTooltip>
                            ) : (
                              ""
                            )}
                          </>
                        ) : (
                          ""
                        ),
                      width: "auto !important",
                      center: true,
                      sortable: true,
                      color: "blue",
                      wrap: true,
                      style: {
                        cursor: "pointer",
                        textAlign: "center",
                      },
                    },
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </BlurSpinner>
    </>
  );
};

export default withRouter(NotasDePedido);
